// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import GoogleMap from '../_raw/ui/icon_googleMap.svg';
import withIconProps from '../withIconProps';

export default withIconProps(GoogleMap);
